// extracted by mini-css-extract-plugin
module.exports = {"login":"login_login__2imHw","bg":"login_bg__3hMq_","blur":"login_blur__N_LgP","paper":"login_paper__23HoY"};